module.exports = __webpack_public_path__ + "img/Ursa_minor.f6aa1242.png";